
let websocketURL = ''; let websocketPushURL = ''; let baseImgUrl = ''; let baseUrl = ''
let groundAirApiUrl = ''; let groundAirPipelineUrl = ''; let groundAirVideoUrl = ''; let groundAirDogTaskUrl = ''
if (window.location.protocol === 'http:') {
  if (window.location.hostname === 'localhost' || window.location.hostname === '192.168.1.101') {
    websocketURL = 'ws://localhost:1235/dj-prod-api/api/v1/ws'// 通过Vite代理连接生产环境
    baseImgUrl = '/dj-cloud-bucket/'// 使用相对路径，通过代理
    baseUrl = '/dj-prod-api/'
    // 中程迭代本地环境配置
    groundAirApiUrl = 'http://192.168.1.100:8010/api'
    groundAirPipelineUrl = 'http://192.168.1.100:8010/api'
    groundAirVideoUrl = 'wss://robotsolution.cn:11081/dksl/stream'
    groundAirDogTaskUrl = 'https://robotsolution.cn:1235/dj-prod-api'
  } else {
    baseImgUrl = '/dj-cloud-bucket/'
    websocketURL = `ws://${window.location.host}/dj-prod-api/api/v1/ws`
    websocketPushURL = `ws://${window.location.host}/prod-api/perception/9527`
    baseUrl = `http://${window.location.host}/dj-prod-api/`
    // 中程迭代生产环境配置
    groundAirApiUrl = '/api'
    groundAirPipelineUrl = '/api'
    groundAirVideoUrl = 'wss://robotsolution.cn:11081/dksl/stream'
    groundAirDogTaskUrl = 'https://robotsolution.cn:1235/dj-prod-api'
  }
} else {
  baseImgUrl = '/dj-cloud-bucket/'
  websocketURL = `wss://${window.location.host}/dj-prod-api/api/v1/ws`
  websocketPushURL = `wss://${window.location.host}/prod-api/perception/9527`
  baseUrl = `https://${window.location.host}/dj-prod-api/`
  // 中程迭代生产环境配置
  groundAirApiUrl = '/api'
  groundAirPipelineUrl = '/api'
  groundAirVideoUrl = 'wss://robotsolution.cn:11081/dksl/stream'
  groundAirDogTaskUrl = 'https://robotsolution.cn:1235/dj-prod-api'
}
export const CURRENT_CONFIG = {
  title: '晨昏线异构多机集群作业管理平台',
  // title: '',
  // license
  appId: '175526', // You need to go to the development website to apply.
  appKey: '3d2782f9b3eeda33451b5b467742e2b', // You need to go to the development website to apply.
  appLicense: 'M2cnhRIGoEnsPyHCbiwwoxl4kinoFr2Wgi0QCTc+NfXHYp+8Dd+fzZOJngweMoZcKZ7Ann4KRzsnWajIFAl4ZpahfzB+lb2XZBqj6XvAOLmIlt9n/3Q5fUbqdgvzgYsUg/UgBZbOVIRB6bBhOHE/5VpR8Xwp+x/eib7C9pZ3sos=', // You need to go to the development website to apply.

  // http
  baseURL: baseUrl, // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  websocketURL: websocketURL, // Example: 'ws://192.168.1.101:6789/api/v1/ws'
  websocketDeepseekURL: 'ws://127.0.0.1:8900/api/ws/chat/',
  // livestreaming
  rtmpURL: 'rtmp://127.0.0.1:11935/test/live?sign=41db35390ddad33f83944f44b8b75ded', // Example: 'rtmp://192.168.1.101/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: 'afc0c5d0392f267f72c88f0a25e39b27',
  securityJsCode: '6f3729a40c34c0ce1c8453cada147f65',
  videoQualityValue: 4, // 默认超清；0-自适应，1-流畅，2-标准，3-高清，4-超清

  customerNo: 'Bu1zO4pc', // 算法客户编号
  geoJson: 'geojson/mimou.geojson', // 乡镇边界
  mapCenter: [103.76805, 30.754004], // 地图中心点
  liveUrlObj: {
    dock: 'rtmp://127.0.0.1:19350/rlive/stream_1873?sign=iEVr6lry',
    drone: 'rtmp://127.0.0.1:19350/rlive/stream_1874?sign=YFdJp5Cr',
    droneFpv: ''
  }, // 直播地址
  cameraObj: {
    dock: '165-0-7',
    drone: '81-0-0',
    droneFpv: ''
  }, // 摄像头编号
  imgUrl: baseImgUrl, // 图片地址
  dronePlayer: 'http://127.0.0.1:9685/flv/live/stream_1874.flv', // 无人机播放地址
  target_height: 660, // 海拔

  // 中程迭代配置
  groundAirApiUrl: groundAirApiUrl, // 设备状态接口地址
  groundAirPipelineUrl: groundAirPipelineUrl, // 管道任务接口地址
  groundAirVideoUrl: groundAirVideoUrl, // 视频流地址
  groundAirDogTaskUrl: groundAirDogTaskUrl, // 机器狗任务接口地址

}
